import React from "react";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  CardActionArea,
  IconButton,
} from "@mui/material";
import { Link } from "react-router-dom"; // Importar o Link
import PeopleIcon from "@mui/icons-material/People";
import DashboardIcon from "@mui/icons-material/Dashboard";
import NewspaperIcon from "@mui/icons-material/Newspaper";

import SideBar from "./components/SideBar";

const Dashboard = () => {
  const cards = [
    { title: "Usuários", description: "Gerenciar Usuários", icon: <PeopleIcon fontSize="large" />, link: "/admin/users" },
    { title: "Notícias", description: "Gerenciar Notícias", icon: <NewspaperIcon fontSize="large" />, link: "/admin/news" },
    { title: "Publicação", description: "Gerenciar Publicação", icon: <DashboardIcon fontSize="large" />, link: "/admin/publications" },
  ];

  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      {/* Sidebar */}
      <SideBar />

      {/* Main Content */}
      <Box sx={{ flexGrow: 1, p: 3, backgroundColor: "#f5f5f5" }}>
        {/* Header */}
        <Typography variant="h4" fontWeight="bold" mb={2}>
          Bem-vindo
        </Typography>

        {/* Cards */}
        <Grid container spacing={2}>
          {cards.map((card, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card sx={{ height: "100%", borderRadius: 2, boxShadow: 3 }}>
                <Link to={card.link} style={{ textDecoration: "none", color: "inherit" }}>
                  <CardActionArea>
                    <CardContent
                      sx={{
                        textAlign: "center",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        height: 150,
                      }}
                    >
                      <IconButton
                        sx={{
                          backgroundColor: "#e0f7fa",
                          mb: 1,
                        }}
                      >
                        {card.icon}
                      </IconButton>
                      <Typography variant="h6" fontWeight="bold">
                        {card.title}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {card.description}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Link>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default Dashboard;
